import React, { useState } from 'react';

import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import PageFlow from "_pages/__routes/PageFlow";
import { useActionExecutor } from "__globals/appActions";

import * as GC from "__globals/GLOBAL-CONSTANTS";
import { logIt } from '__globals/global-functions';


export const ThankYouDefault = props => {

    const { execute } = useActionExecutor();

    logIt( GC.PAGE_THANK_YOU_DEFAULT + " PAGE IS CALLED", null, false );

    return (

        <div id='dv_thank_you_default'>

            <PageCopy
                promotion={props.promotion}
                configKey={"thankYouScreen"}
                jsonKey={GC.TY_DEFAULT}
                entry={props.entry}
            />

            <ActionButtons
                promotion={props.promotion}
                configKey={"thankYouScreen"}
                jsonKey={GC.TY_DEFAULT}
                doAction={props.doAction}
            />

        </div>

    );

}

export default ThankYouDefault;